import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import UserInfo from "../MenuComponent/UserInfo";
import styles from './Settings.module.scss';
import ToggleTheme from "../TogleTheme/ToggleTheme";
import Select from "./Select";
import LangIcon from '../../assets/translate.svg';
import BlackList from "./BlackList";
import SignOutButton from "./SignOutButton";
import { useAppSelector } from "../../hooks/hook";
import { useTranslation } from "react-i18next";
import DeleteUserButton from "./DeleteUserButton";
import React from "react";
const ReloadButton = () => {
    const [isPWA, setIsPWA] = useState(false);
    useEffect(() => {
        const isStandalone = window.matchMedia("(display-mode: standalone)").matches ||
            window.navigator.standalone === true;
        setIsPWA(isStandalone);
    }, []);
    const handleReload = () => {
        window.location.reload();
    };
    if (!isPWA)
        return null;
    return (_jsx("div", { className: styles.item, children: _jsx("button", { onClick: handleReload, children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C" }) }));
};
const Settings = () => {
    const { t } = useTranslation();
    const currentUser = useAppSelector(state => state.app.currentUser);
    return (_jsxs("div", { className: styles.settings, children: [_jsx(UserInfo, { isSettings: true, currentInfo: currentUser }), _jsx("hr", { className: styles.hr }), _jsxs("div", { className: styles.group, children: [_jsx("div", { className: styles.item, children: _jsx(ToggleTheme, {}) }), _jsx("div", { className: styles.item, children: _jsxs("div", { className: styles.container, children: [_jsx("div", { children: _jsx(LangIcon, { fontSize: '1.2rem' }) }), _jsxs("div", { className: styles.containerItem, children: [_jsx("div", { children: _jsx("span", { children: t("language") }) }), _jsx("div", { children: _jsx(Select, {}) })] })] }) }), _jsx(ReloadButton, {})] }), _jsx("hr", { className: styles.hr }), _jsx("div", { className: styles.group, children: _jsx(BlackList, {}) }), _jsx("hr", { className: styles.hr }), _jsxs("div", { className: styles.group, style: { flexDirection: 'row' }, children: [_jsx(SignOutButton, {}), _jsx(DeleteUserButton, {})] })] }));
};
export default Settings;
